module.exports = __webpack_public_path__ + "static/media/larynx_ai3.fca931aa.png";